(function () {
  document.addEventListener("DOMContentLoaded", async () => {
    const wrapper = document.querySelector(".fitments-wrapper");
    if (!wrapper) return;

    // Kullanıcının market'i (us, ca, de, ae, uk, eu vs.)
    const pcMarketHandleFitments = wrapper.dataset.pcmarkethandle;
    if (!pcMarketHandleFitments) return;

    // Market handle her zaman geçerli bir ISO ülke kodu değil:
    // "uk" -> ISO kodu "GB", "eu" ise bir ülke değil, birden fazla ülkeyi kapsayan market.
    // Öncelik Liquid'den gelen gerçek ülke kodu:
    // data-country="{{ localization.country.iso_code }}"
    const HANDLE_TO_COUNTRY = {
      uk: "GB",
      eu: "FR", // EU market'ine bağlı herhangi bir ülke kodu olmalı
    };

    const handle = pcMarketHandleFitments.toLowerCase();
    const country = (
      wrapper.dataset.country ||
      HANDLE_TO_COUNTRY[handle] ||
      handle
    ).toUpperCase();

    const loader = document.querySelector(".loader-parent");
    const table = document.querySelector("#makeModelTable");
    const tbody = document.querySelector("#makeModelTable tbody");
    const searchInput = document.querySelector("#fitmentSearch");

    if (!loader || !table || !tbody) return;

    // Anti-Theft (Pro Sockets)
    const pro_sockets = table.dataset.prosockets || "";
    const proSocketsArr = pro_sockets
      .split('""')
      .map((item) => item.replaceAll('"', "").trim())
      .filter(Boolean);

    const norm = (s) => (s || "").toString().toLowerCase().trim();
    const nospace = (s) => norm(s).replace(/\s+/g, "");
    const slugify = (s) => (s || "").toLowerCase().replace(/\s+/g, "-");
    const debounce = (fn, ms = 250) => {
      let t;
      return (...args) => {
        clearTimeout(t);
        t = setTimeout(() => fn(...args), ms);
      };
    };

    // Storefront API
    const API_VERSION = "2025-10";
    const endpoint = `/api/${API_VERSION}/graphql.json`;
    const headers = {
      "Content-Type": "application/json",
      "X-Shopify-Storefront-Access-Token": "960b68e3d27e55870e9ad333d5a199a1",
    };

    // @inContext(country) sayesinde sadece kullanıcının market'inde
    // aktif (kataloğa dahil) olan ürünler döner, fiyatlar da o market'in para biriminde gelir.
    const PRODUCTS_QUERY = `
      query Fitments($country: CountryCode, $cursor: String) @inContext(country: $country) {
        products(
          first: 250
          after: $cursor
          query: "-product_type:'Merchandise' -product_type:'Merchandise Lifestyle' -product_type:'Merchant' -product_type:'Main Plug' -product_type:'Refurbished' -product_type:'Throttle Response Controller'"
        ) {
          pageInfo {
            hasNextPage
            endCursor
          }
          nodes {
            title
            productType
            variants(first: 100) {
              nodes {
                title
                id
                price {
                  amount
                  currencyCode
                }
                compareAtPrice {
                  amount
                  currencyCode
                }
              }
            }
          }
        }
      }
    `;

    async function fetchProducts(cursor = null) {
      try {
        const response = await fetch(endpoint, {
          method: "POST",
          headers,
          body: JSON.stringify({
            query: PRODUCTS_QUERY,
            variables: { country, cursor },
          }),
        });

        if (!response.ok) {
          console.error("Storefront API HTTP error:", response.status);
          return null;
        }

        const json = await response.json();
        if (json.errors) console.error("GraphQL errors:", json.errors);

        console.log("json.data.products -->", json.data.products);

        return json.data?.products || null;
      } catch (error) {
        console.error("Error fetching GraphQL data:", error);
        return null;
      }
    }

    async function fetchAllProducts() {
      let hasNextPage = true;
      let endCursor = null;
      const allVariants = [];

      while (hasNextPage) {
        const productsData = await fetchProducts(endCursor);
        if (!productsData) break;

        productsData.nodes.forEach((product) => {
          product.variants.nodes.forEach((variant) => {
            // anti theft check
            const variantSocket = variant.title.split("/")[0].trim().split("-")[0].trim();
            const isAntiTheftAvailable = proSocketsArr.includes(variantSocket);

            allVariants.push({
              title: variant.title,
              id: variant.id,
              price: variant.price?.amount || null,
              compare: variant.compareAtPrice?.amount || null,
              currency: variant.price?.currencyCode || null,
              is_anti_theft: isAntiTheftAvailable,
            });
          });
        });

        hasNextPage = productsData.pageInfo.hasNextPage;
        endCursor = productsData.pageInfo.endCursor;
      }

      // Variant title'a göre alfabetik sırala
      allVariants.sort((a, b) => a.title.localeCompare(b.title));

      return allVariants;
    }

    const trNumericCollator = new Intl.Collator("tr", {
      sensitivity: "base",
      numeric: true,
    });

    const getStartYear = (yearStr) => {
      if (!yearStr) return Number.MAX_SAFE_INTEGER;
      const match = yearStr.match(/\d{4}/);
      return match ? parseInt(match[0], 10) : Number.MAX_SAFE_INTEGER;
    };

    async function getMakeModels() {
      const allVariants = await fetchAllProducts();
      const makes = {};

      allVariants.forEach(({ title, id, is_anti_theft }) => {
        const parts = title.split("/").map((item) => item.trim());
        if (typeof parts[0] !== "string" || !/^PC\d/i.test(parts[0])) return;

        const [pcCodeRaw, make, model, rawBody, rawEngine] = parts;
        if (!make || !model) return;

        const pcCode = pcCodeRaw.toUpperCase().replace(/\s+/g, "");

        let body = rawBody || "";
        let year = "";

        const yearMatch = body.match(/\(\d{4}[^)]*\)/);
        if (yearMatch) {
          year = yearMatch[0];
          body = body.replace(yearMatch[0], "").trim();
        }

        const engine = (rawEngine || "").replace(/[()]/g, "").trim();

        if (!makes[make]) makes[make] = {};
        if (!makes[make][model]) makes[make][model] = [];

        const variantId = id ? id.split("/").pop() : null;
        makes[make][model].push({ body, year, engine, pcCode, variantId, is_anti_theft });
      });

      // Year'a göre sıralama: önce başlangıç yılı, eşitse body
      Object.keys(makes).forEach((make) => {
        Object.keys(makes[make]).forEach((model) => {
          makes[make][model].sort((a, b) => {
            const yearDiff = getStartYear(a.year) - getStartYear(b.year);
            if (yearDiff !== 0) return yearDiff;
            return trNumericCollator.compare(a.body, b.body);
          });
        });
      });

      window.__fitmentData = makes;
      return makes;
    }

    // filter: make model or pc  (PC36 and "PC 36" are available)
    function filterData(query, data) {
      const q = norm(query);
      const qNoSpace = nospace(query);

      if (!q) return data;

      const out = {};
      for (const make in data) {
        const models = data[make];
        const makeMatched = norm(make).includes(q);

        for (const model in models) {
          const entries = models[model];
          const modelMatched = norm(model).includes(q);

          const filteredEntries = entries.filter((e) => {
            const pcNoSpace = nospace(e.pcCode); // "PC36"
            const pcMatch =
              pcNoSpace.includes(qNoSpace) || // "pc36"
              norm(e.pcCode).includes(q); // "pc 36"
            return makeMatched || modelMatched || pcMatch;
          });

          if (filteredEntries.length) {
            if (!out[make]) out[make] = {};
            out[make][model] = filteredEntries;
          }
        }
      }
      return out;
    }

    function clearTbody() {
      while (tbody.firstChild) tbody.removeChild(tbody.firstChild);
    }

    function makeTdClickable(td, url) {
      td.style.cursor = "pointer";
      td.addEventListener("click", (e) => {
        if (e.target.closest("a")) return;
        window.open(url, "_blank", "noopener");
      });
    }

    function createLink(href, text) {
      const a = document.createElement("a");
      a.href = href;
      a.textContent = text;
      a.style.textDecoration = "underline";
      a.target = "_blank";
      a.rel = "noopener";
      a.addEventListener("click", (e) => e.stopPropagation());
      return a;
    }

    function createTextTd(text, label) {
      const td = document.createElement("td");
      td.textContent = text;
      td.setAttribute("data-label", label);
      return td;
    }

    // make/model anahtarları alfabetik sırada render ediliyor
    function renderTableFromData(data) {
      clearTbody();

      const makeKeys = Object.keys(data).sort((a, b) => trNumericCollator.compare(a, b));

      for (const make of makeKeys) {
        const models = data[make];
        const modelKeys = Object.keys(models).sort((a, b) => trNumericCollator.compare(a, b));

        const makeRowCount = Object.values(models).reduce(
          (total, entries) => total + entries.length,
          0
        );
        if (makeRowCount === 0) continue;

        const makeSlug = slugify(make);
        let makeRowInserted = false;

        for (const model of modelKeys) {
          const entries = models[model];
          if (!entries || !entries.length) continue;

          const modelSlug = slugify(model);
          const modelUrl = `/products/${makeSlug}-${modelSlug}`;
          let modelRowInserted = false;

          entries.forEach((entry) => {
            const tr = document.createElement("tr");

            if (!makeRowInserted) {
              const tdMake = document.createElement("td");
              const makeUrl = `/collections/${makeSlug}`;
              tdMake.appendChild(createLink(makeUrl, make));
              tdMake.rowSpan = makeRowCount;
              makeTdClickable(tdMake, makeUrl);
              tr.appendChild(tdMake);
              makeRowInserted = true;
            }

            if (!modelRowInserted) {
              const tdModel = document.createElement("td");
              tdModel.appendChild(createLink(modelUrl, model));
              tdModel.rowSpan = entries.length;
              makeTdClickable(tdModel, modelUrl);
              tr.appendChild(tdModel);
              modelRowInserted = true;
            }

            const productUrl = `${modelUrl}?variant=${entry.variantId}`;

            const tdBody = document.createElement("td");
            tdBody.appendChild(createLink(productUrl, entry.body));
            tdBody.setAttribute("data-label", "Body");
            makeTdClickable(tdBody, productUrl);
            tr.appendChild(tdBody);

            tr.appendChild(createTextTd(entry.year, "Year"));
            tr.appendChild(createTextTd(entry.engine, "Engine"));
            tr.appendChild(createTextTd(entry.pcCode, "PC"));
            tr.appendChild(createTextTd(entry.is_anti_theft ? "Yes" : "No", "AT"));

            tbody.appendChild(tr);
          });
        }
      }
    }

    async function init() {
      try {
        const data = await getMakeModels();
        renderTableFromData(data);
      } catch (err) {
        console.error("Fitment table init error:", err);
      } finally {
        loader.style.display = "none";
      }
    }

    const onSearch = debounce(() => {
      const q = searchInput?.value || "";
      const data = window.__fitmentData || {};
      renderTableFromData(filterData(q, data));
    }, 200);

    if (searchInput) {
      searchInput.addEventListener("input", onSearch);
    }

    init();
  });
})();